import React from "react";
import Styles from "./ErrorPage.module.css";
import { useShop } from "./shopService";
import forwardTrackingParameters from "./urlHelpers";

const addDefaultUtms = (link: string) : string => {
  if(link.indexOf('http')>0){
    return link+'?utm_source=repeat&utm_medium=replen_cart_error_page';
  }else{
    return 'http://'+link+'?utm_source=repeat&utm_medium=replen_cart_error_page';
  }
}

const buttonClicked = (shop: any, link: string) => {
  (window as any).analytics.track('Logo clicked Error Page', {
    context: {shop_id: shop.id, shop_name: shop.name}
  });
  const url = addDefaultUtms(link)

  window.location.href = forwardTrackingParameters(url);
};

export const ErrorPage = ({ withText }: { withText?: string }, shop: any) => {
  const shopId = process.env.REACT_APP_SHOP_ID || '0';

  const {
    name,
    logoUrl,
    storeUrl,
    color,
    lightColor,
    error
  } = useShop(shopId);

  const shopLightColor = lightColor || '#fafafa';
  const shopColor = color || '#001343';

  document.body.style.backgroundColor = shopLightColor;
    return (
      <div className={Styles.ErrorPage} style={{ backgroundColor: shopLightColor }}>
        <div className={Styles.Box}>
          <div className={Styles.Logo} onClick={() => buttonClicked(shop, storeUrl)}>
            <img src={logoUrl}/>
          </div>
          <p className={Styles.Oops} style={{color: shopColor}}>Oops...</p>
          <p className={Styles.ErrorText}>{withText}</p>
          <button onClick={() => buttonClicked(shop, storeUrl)} style={{backgroundColor: shopColor, color: shopLightColor}}>
            <span className={Styles.CheckoutTitle}>BACK TO STORE</span>
          </button>
        </div>
      </div>
    );
}
